import { render } from "./Fortin_NumberInput.vue?vue&type=template&id=4954bb38&scoped=true"
import script from "./Fortin_NumberInput.vue?vue&type=script&lang=js"
export * from "./Fortin_NumberInput.vue?vue&type=script&lang=js"

import "./Fortin_NumberInput.vue?vue&type=style&index=0&id=4954bb38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4954bb38"]])

export default __exports__